/**
 * True when `value` is non-nullish and has non-zero length after `String()` coercion.
 */
export function hasNonEmptyValue(value) {
    if (value === null || typeof value === 'undefined') {
        return false;
    }

    return String(value).length > 0;
}
